import { Routes, Route, useLocation, BrowserRouter, Navigate, useNavigate } from "react-router-dom";
import './App.css';
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import Mentor from './Pages/Mentor';
import PricingPlan from './Pages/Pricing_plan';
import { useEffect, useState } from 'react';
import Footer from './component/Footer';
import HeaderNew from './component/Header/HeaderNew';
import Loader from './component/Loader';
import ScrollToTop from "./component/ScrollToTop";
import SidebarIcons from "./component/SidbarIcon";
import { ToastContainer } from "react-toastify";
import Testimonials from "./Pages/Testimonials";
import PrivacyPolicy from "./Pages/PrivacyPolicy ";
import TermsAndConditions from "./Pages/TermsAndConditions";
import RefundPolicy from "./Pages/RefundPolicy";
import School from "./Pages/School";
function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, [location.pathname]);
  const hiddenRoutes = ["/privacy-policy", "/terms-and-conditions", "/refund-policy"];
  useEffect(() => {
    if (window.location.pathname.endsWith("/index.html")) {
      navigate("/", { replace: true });
    }
    else if (window.location.pathname.endsWith("/about-us")) {
      navigate("/", { replace: true });
    }
  }, [navigate]);
  // const showSidebar = !hiddenRoutes.includes(location.pathname);
  return (
    <>
      {loading && <Loader showimg={loading} />}
      {/* {showSidebar && <SidebarIcons />} */}
      <ToastContainer />
      <Routes>
        <Route path="/" element={<><HeaderNew /><SidebarIcons /><Home /><Footer /></>} />
        <Route path="contact" element={<><HeaderNew /><SidebarIcons /><Contact /><Footer /></>} />
        <Route path="mentor" element={<><HeaderNew /><SidebarIcons /><Mentor /><Footer /></>} />
        <Route path="school" element={<><HeaderNew /><SidebarIcons /><School /><Footer /></>} />
        <Route path="pricing" element={<><HeaderNew /><SidebarIcons /><PricingPlan /><Footer /></>} />
        <Route path="testimonials" element={<><HeaderNew /><SidebarIcons /><Testimonials /><Footer /></>} />
        {/* No Header/Footer on These Pages */}
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="refund-policy" element={<RefundPolicy />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
